/* eslint-disable no-unused-vars */
/*Configuration Import */
import apiService from "./apiservice";

/*Library Definition */
const authenticationApi = {
  /*get authenticathion token method */
  auth: () => {
    return apiService
      .get("auth", {
        headers: {
          Authorization: "Login YXBp",
        },
      })
      .then((res) => {
        window.config.token = res.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};

export default authenticationApi;
